import {
  ENVIRONMENT_INITIALIZER,
  ErrorHandler,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { INTERCEPTORS } from '@sites/data-connect';
import { DebugService, ENVIRONMENT } from '@sites/util-environment';
import { connectTracingInterceptorFactory } from './connect-tracing.interceptor';
import { ErrorHandler as CustomErrorHandler } from './error-handler';
import {
  enableSentry,
  notifyNavigationStart,
  registerNavigationRouter,
} from './sentry-lazy';

export function provideUtilErrors() {
  return makeEnvironmentProviders([
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandler,
    },
    {
      provide: INTERCEPTORS,
      useFactory: connectTracingInterceptorFactory,
      deps: [ENVIRONMENT],
      multi: true,
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      useFactory: (debug: DebugService) => () => {
        if (!debug.isDebug()) {
          enableSentry();
        }
      },
      deps: [DebugService],
      multi: true,
    },
    {
      // A navigation ends the current route-visit container transaction
      // so its RPC spans ship (see route-container.ts), and the router is
      // handed to the lazily-instantiated Sentry TraceService so
      // navigations become parameterized `navigation` transactions.
      provide: ENVIRONMENT_INITIALIZER,
      useFactory: () => {
        const router = inject(Router, { optional: true });
        return () => {
          if (!router) return;
          router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
              notifyNavigationStart();
            }
          });
          registerNavigationRouter(router);
        };
      },
      multi: true,
    },
  ]);
}
